export const hero = {
  title: 'Direktimport von Fitnessgeräten',
  subtitle: 'Produkt auf Bestellung',
  button: 'Produkte ansehen'
};

export const product = {
  specs: 'Spezifikationen',
  weight: 'Gewicht',
  volume: 'Volumen',
  onRequest: 'Auf Anfrage'
};

export const total = {
  label: 'GESAMTWERT',
  onRequest: 'Auf Anfrage'
};

export const delivery = {
  shipping: {
    label: 'VERSANDPROGNOSE',
    value: '30 Tage',
    description: 'Nach Erhalt der Anzahlung'
  },
  delivery: {
    label: 'LIEFERPROGNOSE',
    value: '60 Tage',
    description: 'Nach Versand der Geräte'
  },
  packaging: {
    label: 'VERPACKUNG',
    value: 'Sperrholz',
    description: 'Sperrholzkiste'
  },
  warranty: {
    label: 'GARANTIE',
    value: '1 Jahr',
    description: 'Kostenlose Ersatzteile',
    note: '(ohne Versandkosten für Teile)'
  },
  manufacturer: {
    label: 'HERSTELLER',
    value: 'BRTW',
    link: 'Website besuchen'
  }
};

export const financial = {
  title: 'GESAMTWERT (BRL)',
  installment1: {
    title: 'Rate 1 — Prozess starten',
    description: '30% zum Start der Produktion'
  },
  installment2: {
    title: 'Rate 2 — Versandfreigabe',
    description: 'Produktzahlung zur Freigabe'
  },
  installment3: {
    title: 'Rate 3 — Ankunft am Zielort',
    description: 'Hafen oder Flughafen'
  }
};

export const considerations = {
  title: 'Angebotsüberlegungen',
  validity: 'Angebotsgültigkeit: 15 Tage',
  deadline: 'Versandfrist: Die Geräte müssen innerhalb von 3 Monaten versandt werden. Nach diesem Zeitraum wird der Vertrag als ungültig betrachtet.',
  observation: 'Hinweis: Da es sich um einen Direktimport von 10 Geräten handelt, führt jeder Austausch oder die Aufnahme neuer Artikel zu einer Neuberechnung der Werte.',
  assembly: 'Montage und technische Wartung: Nicht enthalten (Verantwortung des Käufers).'
};

export const actions = {
  print: 'Drucken',
  download: 'PDF herunterladen',
  whatsapp: 'Per WhatsApp senden',
  email: 'Per E-Mail senden',
  whatsappText: 'Hallo! Hier ist das kommerzielle Angebot von Moviis:',
  emailSubject: 'Kommerzielles Angebot Moviis',
  emailBody: 'Hallo! Hier ist das kommerzielle Angebot von Moviis:'
};

export const contact = {
  meeting: {
    title: 'Termin vereinbaren',
    button: 'Jetzt vereinbaren'
  },
  email: {
    title: 'Kontaktieren Sie uns',
    button: 'E-Mail senden'
  }
};

export const footer = {
  description: 'Professionelle Hochleistungs-Fitnessgeräte.',
  equipment: {
    title: 'Geräte',
    cardio: 'Cardio',
    strength: 'Krafttraining',
    functional: 'Funktional'
  },
  info: {
    title: 'Informationen',
    catalog: 'Katalog',
    shipping: 'Versand 30 Tage',
    delivery: 'Lieferung 60 Tage',
    warranty: 'Garantie 1 Jahr'
  },
  contactInfo: {
    title: 'Kontakt',
    address: 'R. Voluntários da Pátria, n.º 2468, 6. Stock',
    zipcode: 'PLZ 02402-000',
    phone: '(11) 3255-2877',
    email: 'lp@moviis.com.br',
    hours: 'Montag bis Freitag, 08:30 bis 18:00 (GMT -03:00)'
  },
  copyright: '© 2026 Moviis. Alle Rechte vorbehalten.',
  poweredBy: 'Powered by Readdy'
};

export default {
  'hero.title': hero.title,
  'hero.subtitle': hero.subtitle,
  'hero.button': hero.button,
  'product.specs': product.specs,
  'product.weight': product.weight,
  'product.volume': product.volume,
  'total.label': total.label
};